if (!Array.prototype.toStringNames) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.toStringNames = function () {
    return this.join(' ');
  };
} else {
  console.warn('Array has already a function named toStringNames');
}
